import { useEffect, useRef } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

const HeirDeckPage = () => {
  const iframeRef = useRef(null);

  useEffect(() => {
    document.title = 'HEIR® Corporate Gifting Deck — Meet Mr. Fashion';
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0a]" data-testid="heir-deck-page">
      <iframe
        ref={iframeRef}
        src={`${API}/api/heir/deck`}
        title="HEIR® Corporate Gifting Pitch Deck"
        className="w-full border-0"
        style={{ height: 'calc(100vh - 64px)', marginTop: '64px' }}
        data-testid="heir-deck-iframe"
      />
    </div>
  );
};

export default HeirDeckPage;
